module.exports = __webpack_public_path__ + "bc4105af.woff";